module.exports = __webpack_public_path__ + "static/media/persp4.ff28deeb.jpg";